import React, { useContext } from 'react'
import BazaarVoice from '../../components/BazaarVoice'
import {
    QUESTIONS,
    REVIEWS,
    REVIEW_HIGHLIGHTS
} from '../../constants/bazaarVoiceConstants'
import { Translations } from '../../services/TranslationService'
import { PDP_REVIEWS_ID } from '../../constants/PDPConstants.js'
import '../../css/Reviews.scss'

const Reviews = ({ productDetails }) => {
    const translations = useContext(Translations)
    const { reviews } = translations

    return (
        <div className="sps2-pdp_section sps2-pdp_reviews" id={PDP_REVIEWS_ID}>
            <h2 className="mds-font_header--2a" tabIndex="-1">
                {reviews}
            </h2>
            <BazaarVoice
                stockNumber={productDetails.stockNumber}
                bazaarVoiceClientName={productDetails.bazaarVoiceClientName}
                bazaarVoiceDisplayZone={productDetails.bazaarVoiceDisplayZone}
                bazaarVoiceProductID={productDetails.bazaarVoiceProductID}
                bazaarVoiceShow={REVIEW_HIGHLIGHTS}
            />
            <BazaarVoice
                stockNumber={productDetails.stockNumber}
                bazaarVoiceClientName={productDetails.bazaarVoiceClientName}
                bazaarVoiceDisplayZone={productDetails.bazaarVoiceDisplayZone}
                bazaarVoiceProductID={productDetails.bazaarVoiceProductID}
                bazaarVoiceShow={REVIEWS}
            />
            <BazaarVoice
                stockNumber={productDetails.stockNumber}
                bazaarVoiceClientName={productDetails.bazaarVoiceClientName}
                bazaarVoiceDisplayZone={productDetails.bazaarVoiceDisplayZone}
                bazaarVoiceProductID={productDetails.bazaarVoiceProductID}
                bazaarVoiceShow={QUESTIONS}
            />
        </div>
    )
}

export default Reviews
